/**
    红包
**/
<template>
  <div style="width: 1200px;
    margin: 30px auto;">
        <div class="orderSuccess">
            <div style="margin-bottom:30px">请扫码进行支付:</div>
            <div v-if="this.erweimaUrl==''?true:false">>> <router-link to='/myOrder'> 请前往订单中心查看</router-link></div>
            <div id="qrcode" ref="qrcode"></div>
        </div>
  </div>
</template>
<script>
import { payStatus  } from '@/api/xunyou'
import QRCode from 'qrcodejs2';
import {mapState,mapMutations} from 'vuex'
export default {
  data() {
    return {
    };
  },
  // 注册组件
  components: {},
    computed:{
    ...mapState(['erweimaUrl'])
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){
    this.qrcodes(this.erweimaUrl)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 微信支付二维码跳转
    qrcodes (url) {
       let qrcode = new QRCode('qrcode',{
       width: 200, // 设置宽度，单位像素
       height: 200, // 设置高度，单位像素
       text: url // 设置二维码内容或跳转地址
      })
    }

  },
};
</script>

<style scoped lang="less">
.orderSuccess{
    margin: 100px 0;
    background: white;
    padding: 100px 70px;
    font-size: 14px;
    text-align: center;
    /deep/img{
        display: inline-block !important;
    }
     .address_info{
         margin: 20px 0;
     }
     /deep/.el-collapse{
         border-bottom:0px !important;
     }
     /deep/.el-collapse-item__header {
        font-size: 14px;
        
    }
    span.text_width {
        width: 10%;
        display: inline-block;
    }
    .text_bgcolor{
        display: inline-block;
        width: 80%;
        background: #f5f5f5;
    }
    .order_detail{
        display: inline-block;
        position: absolute;
        right: 30px;
    }
    .payMethods{
        font-size: 18px;
        .payMethods_title{
            margin: 20px 0;
            padding-bottom: 20px;
            border-bottom: 1px solid #ccc;
        }
        .checked_free{
            padding: 10px;
            color: #666;
            font-size: 14px;
            border: 1px solid #e7e7e7;
            margin: 20px 0;
        }
        .payMethods_img {
            // margin: 20px;
            border: 1px solid #ccc;
        }
    }
            button.el-button.buttonBgd.el-button--primary {
               background-color: #ff6700;
               border-color: #ff6700;
               font-size: 18px;
               margin: 20px 0;
           }
           .textCenter {
                text-align: center;
                font-size: 25px;
            }
}
 
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/shoppingcart/wxERweima.vue